import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router)
  {
    
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {


    var user = this.authService.getLoginResult();

    var ispageAllowed = true;

    
    //JB: Need to test this again with a few users
    //JB: Ensure that login is always allowed
    if (state.url.indexOf('/account/login') >= 0) {
      ispageAllowed = true;
    }

    if (state.url == '/') {
      ispageAllowed = true;
    }

    if (user != null) {

      for (var i = 0; i < user.MenuList.length; i++) {

        for (var p = 0; p < user.MenuList[i].Items.length; p++) {

          var found = state.url.indexOf(user.MenuList[i].Items[p].RouterLink);

          if (found >= 0) {
            ispageAllowed = true;
          }
        }
      }

   
    }
    else {
      ispageAllowed = true;
    }

    return this.authService.isLoggedIn.pipe(
      take(1),
      map((isLoggedIn: boolean) => {

        if (ispageAllowed == false) {
          this.router.navigate([user.DefaultLandingPage]);
          return false;
        }

        if (!isLoggedIn) {

          this.router.navigate(['/account/login']);

          return false;
        }
        return true;
      })
    );
  }
}
